import { render } from "./FullscreenModal.vue?vue&type=template&id=45f951b3&scoped=true"
import script from "./FullscreenModal.vue?vue&type=script&lang=js"
export * from "./FullscreenModal.vue?vue&type=script&lang=js"

import "./FullscreenModal.vue?vue&type=style&index=0&id=45f951b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f951b3"]])

export default __exports__